import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { branding } from '../constants/branding';
import { emailVerificationService } from '../services/emailVerificationService';

const VerifyEmail: React.FC = () => {
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);

  useEffect(() => {
    const token = searchParams.get('token');
    if (!token) {
      setError('Verification token is missing.');
      setLoading(false);
      return;
    }

    const confirm = async () => {
      try {
        const result = await emailVerificationService.confirmToken(token);
        setSuccess(result.message || 'Email verified successfully. You can return to registration.');
      } catch (err: any) {
        setError(
          err?.response?.data?.errors?.[0]
            || err?.response?.data?.message
            || 'Email verification failed. The link may be expired or already used.'
        );
      } finally {
        setLoading(false);
      }
    };

    confirm();
  }, [searchParams]);

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: branding.backgroundGradient,
      padding: 24
    }}>
      <div style={{
        width: '100%',
        maxWidth: 520,
        background: '#fff',
        borderRadius: 16,
        boxShadow: '0 10px 30px rgba(0, 0, 0, 0.08)',
        padding: 32
      }}>
        <h2 style={{ marginTop: 0, color: branding.primaryColor }}>Email verification</h2>
        {loading && <p>Verifying your email link...</p>}
        {!loading && success && <p style={{ color: '#16a34a' }}>{success}</p>}
        {!loading && error && <p style={{ color: '#dc2626' }}>{error}</p>}

        <div style={{ marginTop: 16, display: 'flex', gap: 12, flexWrap: 'wrap' }}>
          <Link to="/register/personal" style={{ color: branding.primaryColor, textDecoration: 'none', fontWeight: 600 }}>
            Return to personal registration
          </Link>
          <Link to="/register/business" style={{ color: branding.primaryColor, textDecoration: 'none', fontWeight: 600 }}>
            Return to business registration
          </Link>
        </div>
      </div>
    </div>
  );
};

export default VerifyEmail;
